import { clsx } from 'clsx';

import { ImageActionButton } from '../imageActionButton/imageActionButton';

import styles from './selectedIndicator.module.css';

interface SelectedIndicatorProps {
  disabled?: boolean;
  isSelected: boolean;
  onToggle: () => void;
  productName: string;
}

/** Toggles a product card's selection. The caller decides when to show it. */
export const SelectedIndicator = ({
  disabled = false,
  isSelected,
  onToggle,
  productName,
}: SelectedIndicatorProps) => (
  <ImageActionButton
    className={clsx(styles['indicator'], {
      [styles['indicator_selected']]: isSelected,
    })}
    disabled={disabled && !isSelected}
    onClick={onToggle}
    aria-label={`Select ${productName}`}
    aria-pressed={isSelected}
  >
    <span className={styles['dot']} aria-hidden="true" />
  </ImageActionButton>
);
